[
 {
  "id": "panel",
  "x": 67,
  "y": 174,
  "w": 808,
  "h": 1388
 }
]